// Styles
import './VDivider.sass'

// Types
import { VNode } from 'vue'

// Mixins
import Themeable from '../../mixins/themeable'

export default Themeable.extend({
  name: 'v-divider',

  props: {
    inset: Boolean,
    vertical: Boolean,
    classPrefix: {
      type: String,
      default: '',
    },
  },

  render (h): VNode {
    // WAI-ARIA attributes
    let orientation
    if (!this.$attrs.role || this.$attrs.role === 'separator') {
      orientation = this.vertical ? 'vertical' : 'horizontal'
    }
    return h('hr', {
      class: {
        [`${this.classPrefix}v-divider`]: true,
        [`${this.classPrefix}v-divider--inset`]: this.inset,
        [`${this.classPrefix}v-divider--vertical`]: this.vertical,
        ...this.themeClasses,
      },
      attrs: {
        role: 'separator',
        'aria-orientation': orientation,
        ...this.$attrs,
      },
      on: this.$listeners,
    })
  },
})
